// extracted by mini-css-extract-plugin
module.exports = {"UploadButton":"ImageUpload_UploadButton__30hHB","HiddenInput":"ImageUpload_HiddenInput__2WkRN","Details":"ImageUpload_Details__1oFR_","FileName":"ImageUpload_FileName__1tH8t"};